import { message } from 'antd'
import { AxiosError } from 'axios'
import { ZodError } from 'zod'

export function parseError(error: any) {
  if (error instanceof ZodError) {
    const formattedErrors = error.issues.map((e) => e.message)
    message.error(formattedErrors[0])
    return
  }

  if (error instanceof AxiosError) {
    if (error?.response?.data?.message) {
      message.error(error.response.data.message)
    } else {
      message.error(error.message)
    }
  } else {
    message.error('An unexpected error occurred')
  }
}
